import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Expert } from '../expert-card/expert-card';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-expert-profile-header',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './expert-profile-header.html',
  styleUrl: './expert-profile-header.scss',
})
export class ExpertProfileHeaderComponent {
  @Input({ required: true }) expert!: Expert;

  getInitials(): string {
    if (!this.expert?.name) return 'EX';
    const parts = this.expert.name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }
}
